import FlexboxPaneContainer from './FlexboxPaneContainer'
import FlexboxPaneChild from './FlexboxPaneChild'

const FlexboxPane = {
    Child: FlexboxPaneChild,
    Container: FlexboxPaneContainer
}

export default FlexboxPane
